import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncateWords',
    standalone: false
})
export class TruncateWordsPipe implements PipeTransform {
  transform(value: string, words: number): string {
    if (!value) return '';
    
    const wordArray = value.split(' ');
    return wordArray.slice(0, words).join(' ');
  }
}